import "@theme/jib/init.scss";

import "nette.ajax.js";

import "./jib/index";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

document.addEventListener("DOMContentLoaded", () => {
	$.nette.init()

	if ($('.device-not-supported').length) {
		adjustBodyHeight()
		window.addEventListener("resize", adjustBodyHeight)

		$('.show-info').on('click', function () {
			$('#page-waiting').addClass('d-none')
			$('#page-info').removeClass('d-none')
		})

		$('.hide-info').on('click', function () {
			$('#page-info').addClass('d-none')
			$('#page-waiting').removeClass('d-none')
		})
	}
});

function adjustBodyHeight() {
	$("body").css("height", window.innerHeight);
}
